<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<h2 mat-dialog-title>{{data.requestTitle}}</h2>

<mat-dialog-content>
    <h3 *ngIf="data.subTitle != null">{{data.subTitle}}</h3>

    @if (data.securityApprovalMethod === securityApprovalMethodType.PERCENT_RULE) {
        <div class="approval-note">{{'RECOVERY_KEY_ACCESS_DIALOG_APPROVAL_NOTE' | translate : {percent: data.minimumApprovalPercentRequired} }}</div>
    } @else {
        <div class="approval-note">{{'RECOVERY_KEY_ACCESS_DIALOG_APPROVAL_NOTE_PLUS_ONE' | translate}}</div>
    }
    <div class="contact-note">{{'RECOVERY_KEY_ACCESS_DIALOG_CONTACT_NOTE' | translate}}</div>

    <div class="container">
        <ng-container *ngFor="let approver of data.results">
            <div class="approver-wrapper">
                <h1 class="title">{{approver.firstName}} {{approver.lastName}}</h1>
                <p class="content">{{approver.email}}</p>
            </div>
        </ng-container>
    </div>
</mat-dialog-content>

<div mat-dialog-actions class="button-wrapper">
    <div>
        <mat-checkbox [formControl]="notifyApprovers">{{'NOTIFY_APPROVERS' | translate}}</mat-checkbox>
    </div>
    <div>
        <button mat-raised-button color="warn" (click)="onSendRequest()" type="button">{{'RECOVERY_KEY_ACCESS_DIALOG_REQUEST_APPROVAL' | translate}}</button>
        <button mat-raised-button color="primary" (click)="close()" type="button">{{'H_CLOSE' | translate}}</button>
    </div>
</div>
